export const AuthRoute = {
  callback: "callback",
};
